import {
  useNavigate,
  useParams,
  useLocation,
  generatePath,
} from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { SecurityLogForm } from '@ui/src';
import { clearLogPanelState } from '../store/slices/security';
import { useLazyGetCustomerLocksAuditLogItemQuery } from '../store/services/individual';

import ROUTES from '../../../routes';

const IndividualCustomerSecurityLogForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { customerId } = useParams();
  const { search, state: locationState } = useLocation();

  const [getLogItem, { isLoading, isFetching }] =
    useLazyGetCustomerLocksAuditLogItemQuery();

  const {
    individualCustomers: {
      info: {
        security: { logItem },
      },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  return (
    <SecurityLogForm
      clearLogPanelState={() => dispatch(clearLogPanelState())}
      onClose={() => {
        const link =
          locationState?.backLink ||
          generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS, {
            customerId: customerId as string,
          });

        navigate(`${link}${search || ''}`);
      }}
      getLogItem={getLogItem}
      activePermissions={activePermissions}
      logItem={logItem}
      isLoading={isLoading}
      isFetching={isFetching}
      wuthoutCustomer
    />
  );
};

export default IndividualCustomerSecurityLogForm;
